import * as React from 'react'

function SvgIllustration404(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 330 250"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      {...props}
    >
      <defs>
        <linearGradient x1="50%" y1="1.125%" x2="50%" y2="97.418%" id="illustration-404_svg__e">
          <stop stopColor="#D6DAE1" stopOpacity={0.424} offset="0%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-404_svg__f">
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity={0.388} offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="64.379%" x2="50%" y2="86.745%" id="illustration-404_svg__g">
          <stop stopColor="#D6DAE1" stopOpacity={0.389} offset="0%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="1.125%" x2="50%" y2="96.416%" id="illustration-404_svg__h">
          <stop stopColor="#D6DAE1" stopOpacity={0.239} offset="0%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient
          x1="23.134%"
          y1="100%"
          x2="23.134%"
          y2="33.95%"
          id="illustration-404_svg__i"
        >
          <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
          <stop stopColor="#FFF" offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-404_svg__j">
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1=".363%" x2="50%" y2="97.578%" id="illustration-404_svg__k">
          <stop stopColor="#D6DAE1" stopOpacity={0.424} offset=".784%" />
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="99.836%" />
        </linearGradient>
        <linearGradient x1="10.289%" y1="90.821%" x2="10.289%" y2="0%" id="illustration-404_svg__l">
          <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
          <stop stopColor="#FFF" offset="100%" />
        </linearGradient>
        <ellipse id="illustration-404_svg__c" cx={105.746} cy={105.09} rx={105.746} ry={105.09} />
        <path id="illustration-404_svg__a" d="M0 0h330v250H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="illustration-404_svg__b" fill="#fff">
          <use xlinkHref="#illustration-404_svg__a" />
        </mask>
        <g mask="url(#illustration-404_svg__b)">
          <g transform="translate(59 3)">
            <mask id="illustration-404_svg__d" fill="#fff">
              <use xlinkHref="#illustration-404_svg__c" />
            </mask>
            <use fill="#F5F5F5" xlinkHref="#illustration-404_svg__c" />
            <g mask="url(#illustration-404_svg__d)">
              <g transform="translate(15 115)">
                <rect fill="url(#illustration-404_svg__e)" width={44} height={95} rx={3} />
                <path fill="url(#illustration-404_svg__f)" d="M5 9h8v18H5zM18 9h8v18h-8z" />
              </g>
            </g>
            <g mask="url(#illustration-404_svg__d)">
              <g transform="translate(66 99)">
                <rect fill="url(#illustration-404_svg__g)" width={44} height={104} rx={3} />
                <path fill="#FFF" d="M5 9h8v18H5zM18 9h8v18h-8z" />
              </g>
            </g>
            <g mask="url(#illustration-404_svg__d)">
              <g transform="translate(72 130)">
                <rect fill="url(#illustration-404_svg__h)" x={45} width={53} height={95} rx={3} />
                <path
                  d="M58 34v18h-8V34h8zm0-25v18h-8V9h8zm13 0v18h-8V9h8z"
                  fill="url(#illustration-404_svg__i)"
                />
                <path fill="url(#illustration-404_svg__j)" d="M0 18h8v18H0z" />
              </g>
            </g>
            <g mask="url(#illustration-404_svg__d)">
              <g transform="translate(28 67)">
                <rect fill="url(#illustration-404_svg__k)" width={44} height={48} rx={3} />
                <path fill="url(#illustration-404_svg__l)" d="M5 9h8v18H5z" />
                <path fill="#FFF" d="M18 9h8v18h-8z" />
              </g>
            </g>
            <g mask="url(#illustration-404_svg__d)">
              <g transform="translate(36.91 44.482)">
                <rect
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                  x={0.3}
                  y={0.3}
                  width={137.33}
                  height={109.371}
                  rx={2}
                />
                <path
                  d="M135.93.3c.47 0 .894.19 1.202.498.308.308.498.733.498 1.202h0v8.836H.3V2c0-.47.19-.894.498-1.202A1.695 1.695 0 012 .3h0z"
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                />
                <ellipse fill="#D96156" cx={8.445} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#F7B035" cx={16.889} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#57BB52" cx={25.334} cy={5.568} rx={2.815} ry={2.784} />
              </g>
              <path
                d="M140.357 116.628c2.362-4.782 3.7-10.12 3.7-15.761 0-20.273-17.092-36.717-38.163-36.717-21.071 0-38.163 16.444-38.163 36.717 0 .254.017.508.017.763l13.706-16.365h7.96l-11.791 17.143h3.831v-4.353l8.19-12.281v31.124h-8.19v-6.546H69.02c3.55 12.79 14.086 22.831 27.446 26.104-.859 2.081-3.352 7.102-7.497 7.992-5.136 1.112 13.937.27 27.544-8.31 10.453-2.907 19.056-9.993 23.73-19.24h-8.059v-6.546h-13.722v-8.706l13.722-16.38h7.761l-11.592 17.142h3.831v-4.687l8.19-12.233v24.864l-.016 6.276zm-46.955-4.372a7.056 7.056 0 01-.592-2.88v-17.15c0-1.024.197-1.984.592-2.88a7.394 7.394 0 011.614-2.335 7.636 7.636 0 012.404-1.568 7.632 7.632 0 012.964-.576h6.717c1.054 0 2.042.192 2.964.576a7.882 7.882 0 012.371 1.536l-7.294 10.35v-1.84c0-.383-.132-.703-.395-.96a1.361 1.361 0 00-.988-.383c-.395 0-.725.128-.988.384a1.283 1.283 0 00-.395.96v5.76l-8.447 11.966a6.82 6.82 0 01-.527-.96zm22.305-3.137c0 1.025-.2 1.986-.6 2.883-.4.897-.949 1.682-1.631 2.339a7.731 7.731 0 01-2.432 1.57 7.788 7.788 0 01-2.997.576h-6.795a7.788 7.788 0 01-2.998-.576 7.731 7.731 0 01-2.431-1.57 7.799 7.799 0 01-.833-.961l8.26-11.58v4.052c0 .384.134.704.4.96.267.257.6.385 1 .385.399 0 .732-.128.998-.384.267-.257.4-.577.4-.961v-7.977l7.71-10.827c.55.592 1 1.265 1.333 2.018.4.897.6 1.858.6 2.883v17.17h.016z"
                fill="#126BFB"
                fillRule="nonzero"
              />
            </g>
          </g>
          <g transform="translate(59 13)">
            <circle stroke="#18263C" strokeWidth={0.6} fill="#FFF" cx={20} cy={20} r={19.7} />
            <path
              d="M20.94 23.06v-.34c0-.48.1-.92.32-1.32.18-.36.46-.72.84-1.04.94-.82 1.5-1.34 1.68-1.56.5-.64.76-1.46.76-2.44 0-1.2-.4-2.16-1.2-2.86-.8-.72-1.84-1.06-3.12-1.06-1.48 0-2.64.42-3.48 1.28-.84.84-1.26 1.98-1.26 3.44h2.1c0-.88.18-1.56.54-2.04.4-.58 1.06-.86 1.96-.86.72 0 1.3.2 1.7.6.38.4.58.94.58 1.64 0 .52-.2 1-.56 1.46l-.34.38c-1.24 1.1-2 1.92-2.26 2.48-.28.52-.4 1.16-.4 1.9v.34h2.14zM19.86 27c.4 0 .76-.14 1.04-.4.28-.28.44-.62.44-1.04 0-.42-.14-.76-.42-1.02-.28-.28-.64-.4-1.06-.4-.4 0-.76.12-1.04.4-.28.26-.42.6-.42 1.02 0 .4.14.74.42 1.02.28.28.64.42 1.04.42z"
              fill="#126BFB"
              fillRule="nonzero"
            />
          </g>
          <path
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
            d="M260.455 236.164h7.266v4.008h-7.266zM238.825 236.164h7.266v4.008h-7.266z"
          />
          <path
            d="M268.2 238.637c.523 0 .995.212 1.338.554a1.886 1.886 0 01.458 1.932 3.895 3.895 0 01-3.702 2.675h0-11.406a3.484 3.484 0 01-3.388-2.653 2.016 2.016 0 01.232-1.53 2.016 2.016 0 011.246-.919h0zM246.401 238.637c.522 0 .995.212 1.338.554a1.886 1.886 0 01.458 1.932 3.895 3.895 0 01-3.702 2.675h0-11.406a3.484 3.484 0 01-3.388-2.653 2.016 2.016 0 01.232-1.53 2.016 2.016 0 011.246-.919h0z"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#D6DAE1"
          />
          <path
            d="M282.903 142c.705 11.731.363 24.977-1.025 39.737-1.387 14.76-5.69 33.068-12.908 54.926h-9.745c-5.809-54.621-7.086-87.417-3.831-98.388 3.254-10.971 12.424-9.73 27.51 3.725z"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M232.497 131.561c-6.056 7.874-5.091 10.52-5.091 42.063 0 21.028 3.098 42.04 9.294 63.039h10.897c5.623-44.752 8.894-71.274 9.815-79.565a314.63 314.63 0 001.77-24.793c-13.753-5.745-22.648-5.993-26.685-.744zM221.724 93.145c.817-2.96-1.354-1.909-6.513 3.155-6.479 6.357-7.516 14.064-2.657 18.05 5.843 4.794 20.369 6.113 22.376 4.651.036-.026 4.293-2.075 2.866-4.86-1.427-2.784-5.045-.782-5.176-.833-1.858-.724-9.454-1.352-4.707-5.815 1.727-1.625 2.82-2.366 3.955-3.332l-10.144-11.016z"
            stroke="#1A1A1A"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M252.048 83.38c-2.943-.051-4.491-.01-4.644.125l.949-10.51 6.714-.606 1.515 11.086c-.08-.012-1.59-.043-4.534-.095z"
            stroke="#1A1A1A"
            strokeWidth={0.5}
            fill="#FFF"
          />
          <path
            d="M254.799 53.94c5.502 2.707 8.216 6.145 8.144 10.315-.063 3.574-1.327 7.258-3.793 11.05a4 4 0 01-3.517 1.816l-10.195-.417a4 4 0 01-3.55-2.51c-3.121-7.799-2.9-13.403.665-16.812 3.921-3.75 4.345-6.087 1.271-7.008L254.8 53.94z"
            fill="#18263C"
          />
          <path
            d="M270.306 86.244c5.197 11.07 13.114 13.81 23.752 8.219 2.977-1.565 9.52-8.64 5.815-16.718-2.073-4.52-6.927-11.746-14.562-21.677-.104-4.355-1.749-6.105-4.934-5.25-4.777 1.28-3.538 3.824-1.839 5.25l4.433 3.721c9.356 13.579 9.436 20.441.24 20.586-9.195.146-13.497 2.102-12.905 5.869z"
            stroke="#1A1A1A"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M234.862 79.947c3.226-.43 8.713.204 11.605 1.23 2.893 1.027 11.227-.008 14.62-1.23.994-.358 11.964-4.681 19.838.82 5.364 7.962 6.837 13.882 4.42 17.758-.305.491-4.481 1.282-12.528 2.372 6.847 13.59 10.931 28.465 12.253 44.626h-62.598c4.134-23.02 7.947-37.208 11.439-42.564.672-1.03-4.988 5.312-5.107 5.183l-14.7-11.971c4.166-9.53 11.086-14.937 20.758-16.224z"
            stroke="#1A1A1A"
            strokeWidth={0.6}
            fill="#D6DAE1"
          />
        </g>
      </g>
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgIllustration404)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
